export const MOVE_INDEX_WORKER_PROJECT_NAME = "move_index_worker_project";

export const MOVE_INDEX_WORKER_PROJECT_DESC = `Moves an Index Worker job to another Index Worker project.

Use when the user asks to move an existing Index Worker job into a different project.

Input:
- 'indexWorkerId' (required): The Index Worker ID to move.
- 'targetProjectId' (required): Destination Index Worker project ID.

Notes:
- This is a write operation (mutation) and requires confirmation.
- Returns navigation helpers ('workspaceId', 'projectPath', 'jobPath', 'jobUrl') so the assistant can provide a direct link after moving.`;
